import React from "react";
import styles from "./index.module.scss";
import { renderRichText } from "@/utils/formatters";
import { useRouter } from "next/router";

const ProductHighlight = ({ productHighlightsData }) => {
  const { locale } = useRouter()
  
    if (!productHighlightsData?.image?.length) return null;

    const items = productHighlightsData.image

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        {items.map((item) => {
          const {
            imageUrl,
            name,
            alt,
            description,
          } = item.fields || {};

          if (!imageUrl) return null;

          return (
            <div className={styles.card} key={item.sys.id}>
              <img
                src={imageUrl}
                alt={alt || name || ""}
                className={styles.image}
              />

              <div className={styles.details}>
                {name && (
                  <div className={styles.title}>
                    {name}
                  </div>
                )}

                {description && (
                  <div className={styles.description}>
                    {renderRichText(description, locale)}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};
export default ProductHighlight;
